import { forkJoin as observableForkJoin, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { PortalService } from './portal.service';

import { PersonalDataRequestService } from './personal-data-request.service';

@Injectable()
export class PortalsResolveService {
    constructor(
        private portalService: PortalService,
        private personalDataRequestService: PersonalDataRequestService,
    ) {}

    resolve(): Observable<any> | Promise<any> | any {
        return new Promise((resolve) => {
            observableForkJoin(this.portalService.getPortal(), this.personalDataRequestService.getRequest()).subscribe(
                (response) => {
                    // do something with response
                    return resolve(response);
                },
            );
        });
    }
}
